import { Component } from '@nicolas-riciotti/light2'
import Tween from '../helpers/Tween.js';

import Lenis from '../helpers/Lenis'

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

const USE_SPA = true;

export default class WebApplication extends Component {

  created() {

    Lenis.on('scroll', e => {
    });

    console.log('LOCAL', localStorage['accessibility']);

    this.isDebug             = false;
    this.clickSettingsToggle = this.clickSettingsToggle.bind(this);
    // this.siteMotionChange    = this.siteMotionChange.bind(this);
    this.settings = {
      accessibility: {
        enabled:  localStorage['accessibility'] === 'true',//(localStorage.motion === 'reduced-motion' || (!('motion' in localStorage) && window.matchMedia('(prefers-reduced-motion: reduce)').matches)),
        // flag:     'reduced-motion',
        // inversed: false,
        toggle:   null,
      }
    }

    this.onLinkDown         = this.onLinkDown.bind(this)
    this.onApplicationClick = this.onApplicationClick.bind(this)
    this.onApplicationHover = this.onApplicationHover.bind(this)
    this.linksCache         = {};
    this.isTransitioning    = false;

  }

  attached() {
    
    document.addEventListener('keydown', e => {
      if (e.ctrlKey && (e.key === 'h' || e.key === 'H')) {
        e.preventDefault();  
        this.isDebug = !this.isDebug;
        this.classList.toggle('is-debug', this.isDebug);
      }
    });

    requestAnimationFrame(()=>{
      this.classList.add('is-ready');
    });

    // On page load (although it is best to add inline in `head` to avoid FOUC).
    for (const [type, setting] of Object.entries(this.settings)) {
      const $els = this.querySelectorAll(`[data-site-settings-type="${type}"]`)
      this.settings[type].toggles = $els;
      console.log('SETTINGS', type, setting.enabled);
      this.updateSetting(type, setting.enabled);
      $els?.forEach($el => {
        $el?.addEventListener('change', this.clickSettingsToggle, false);
      });
    }
    // Respond to OS level settings changes.
    // const motionkModePreference = window.matchMedia('(prefers-reduced-motion: reduce)')
    // motionkModePreference.addEventListener('change', this.siteMotionChange, false)

    // Scroll Anchor smooth anim.
    // Lenis owns the scroll position, so the browser's native #hash jump is
    // suppressed — we must scroll explicitly via Lenis. We also offset by the
    // fixed header so the target doesn't land underneath it.
    const anchors = document.querySelectorAll('a[href*="#"]');
    anchors.forEach(anchor => {
      anchor.addEventListener("click", function (e) {
        const href = this.getAttribute("href");
        const [path, hash] = href.split('#');
        if (!hash) return;
        const currentPath = window.location.pathname;
        if (path === '' || path === currentPath || path === currentPath + '/') {
          const target = document.getElementById(hash);
          if (target) {
            e.preventDefault();
            const header = document.querySelector('app-header');
            const offset = header ? -(header.getBoundingClientRect().bottom + 20) : -120;
            if (typeof Lenis?.scrollTo === 'function') {
              Lenis.scrollTo(target, { offset });
            } else {
              target.scrollIntoView({ behavior: 'smooth' });
            }
            // Move focus for a11y once the scroll settles. Guarded: most
            // section targets have no focusable child.
            setTimeout(() => {
              const focusable = target.querySelector('input, button, a');
              if (focusable) focusable.focus({ preventScroll: true });
            }, 600);
          }
        }
      });
    });

    // For accessibiloty
    document.querySelectorAll('[scroll-into-view]').forEach(link => {
      link.addEventListener('focus', (e) => {
        const section = e.target.closest('article');
        if (section) {
          section.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });

    document.querySelectorAll('[audio-player-wrapper]').forEach((el, index) => {
      const transcript = el.querySelector('[transcript]');
      if (transcript) {
        // Ensure transcript has a stable id
        if (!transcript.id) {
          transcript.id = `audio-transcript-${index + 1}`;
        }
        // Transcript styling / accessibility defaults
        transcript.classList.add('text-caption');
        transcript.hidden = true;
        transcript.style.marginBottom = '30px';
        transcript.setAttribute('aria-hidden', 'true');
        transcript.setAttribute('role', 'region');
        transcript.setAttribute('aria-label', 'Audio transcript');
        // Add toggle button only once
        let transcriptToggle = el.querySelector('[data-transcript-toggle]');
        if (!transcriptToggle) {
          transcriptToggle = document.createElement('button');
          transcriptToggle.type = 'button';
          transcriptToggle.classList.add('text-caption', 'transcript-button');
          transcriptToggle.style.marginTop = '10px';
          transcriptToggle.style.marginBottom = '10px';
          transcriptToggle.setAttribute('data-transcript-toggle', '');
          transcriptToggle.setAttribute('aria-controls', transcript.id);
          transcriptToggle.setAttribute('aria-expanded', 'false');
          transcriptToggle.textContent = 'Show transcript';
          transcript.parentNode.insertBefore(transcriptToggle, transcript);
          transcriptToggle.addEventListener('click', () => {
            const isHidden = transcript.hidden;
            transcript.hidden = !isHidden;
            transcript.setAttribute('aria-hidden', String(!isHidden));
            transcriptToggle.setAttribute('aria-expanded', String(isHidden));
            transcriptToggle.textContent = isHidden ? 'Hide transcript' : 'Show transcript';
          });
        }
      }
      const obs = new MutationObserver(() => {
        const offscreen = el.querySelector('.mejs-offscreen');
        if (offscreen) {
          offscreen.style.display = 'none';
        }
        const playBtn = el.querySelector('.mejs-play button');
        if (playBtn) {
          playBtn.setAttribute('aria-label', 'Play audio');
          playBtn.innerHTML = `
            <svg class="play-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 27" aria-hidden="true" focusable="false"><path d="M15.871 13.76.498 26.831V.686L15.871 13.76Z"/></svg>
            <svg class="pause-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 27" aria-hidden="true" focusable="false"><path d="M-.024.027h5.701v27.098H-.024zM10.385.045h5.701v27.098h-5.701z"/></svg>
          `;
        }
        const wrapper = el.querySelector('.mejs-container');
        if (wrapper) {
          wrapper.removeAttribute('aria-label');
          wrapper.removeAttribute('tabindex');
          wrapper.removeAttribute('role');
          obs.disconnect();
        }
      });
      obs.observe(el, { childList: true, subtree: true });
    });


    const $searchClear = document.querySelector('[search-clear]');
    const $searchInput = document.querySelector('[search-input]');
    $searchClear?.addEventListener('click', e => {
      $searchInput.value = '';
    });


    if (USE_SPA) {
      this.addEventListener('click', this.onApplicationClick);
      this.addEventListener('mouseover', this.onApplicationHover);
      window.addEventListener('popstate', (e)=>{
        const url = new URL(window.location.href, document.baseURI).toString();
        if (this.isTransitioning) {
          window.location.href = url;
          return;
        }
        this.loadPageurl(url, null, true);
      });

      window.addEventListener('statechange', (e)=>{
        const url = new URL(window.location.href, document.baseURI).toString();
        if (this.isTransitioning) {
          window.location.href = url;
          return;
        }
        this.loadPageurl(url, null, true);
      });
    }

  }

  // Page transitions run several scrollTo(0) resets mid-fade; user scrolling
  // in that window gets yanked back ("popping"). Freeze wheel/touch scrolling
  // for the duration — the page is mid-animation and not meaningfully
  // scrollable anyway.
  beginTransition() {
    this.isTransitioning = true;
    this._scrollBlocker = this._scrollBlocker || ((e) => e.preventDefault());
    window.addEventListener('wheel', this._scrollBlocker, { passive: false });
    window.addEventListener('touchmove', this._scrollBlocker, { passive: false });
  }

  endTransition() {
    this.isTransitioning = false;
    if (this._scrollBlocker) {
      window.removeEventListener('wheel', this._scrollBlocker, { passive: false });
      window.removeEventListener('touchmove', this._scrollBlocker, { passive: false });
    }

    console.log('BIND clickSettingsToggle');
    for (const [type, setting] of Object.entries(this.settings)) {
      const $els = this.querySelectorAll(`[data-site-settings-type="${type}"]`)
      this.settings[type].toggles = $els;
      $els?.forEach($el => {
        $el?.removeEventListener('change', this.clickSettingsToggle, false);
        $el?.addEventListener('change', this.clickSettingsToggle, false);
      });
    }

  }

  onApplicationClick(e) {
    let n = e.target;
    while(n.parentNode && n !== document) {
      if (n.tagName == 'A') {
        this.onLinkDown(e, n)
        break;
      }
      n = n.parentNode
    }
  }

  onApplicationHover(e) {
    let n = e.target;
    while(n.parentNode && n !== document) {
      if (n.tagName == 'A') {
        const href = n.getAttribute('href') || '';
        if ( /^mailto/.test(href.trim()) || (n.hasAttribute('target') && n.getAttribute('target') == '_blank') || n.hasAttribute('download')) {
          return true;
        }
        else {
          this.cacheLink(e, n);
          break;
        }
      }
      n = n.parentNode
    }
  }
  
  cacheLink(e, target) {
    let href = target.getAttribute('href');
    // Don't prefetch same-page anchors — the browser handles those natively.
    const dest = new URL(href, document.baseURI);
    if (dest.hash && dest.pathname === window.location.pathname && dest.origin === window.location.origin) {
      return;
    }
    if (window.location.href == new URL(href, document.baseURI).href) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    if ( /^mailto/.test(href.trim()) || (target.hasAttribute('target') && target.getAttribute('target') == '_blank') || target.hasAttribute('download')) {
      return true;
    }
    const url = new URL(href, document.baseURI).toString();
    this.preparePage(url, target);
  }

  onLinkDown(e, target) {
    let href = target.getAttribute('href');
    if (window.event.ctrlKey || window.event.metaKey || !href) {
      return
    }
    // Same-page anchors (footnote refs etc.): let the browser jump natively
    // instead of running a page transition to the page we're already on.
    const dest = new URL(href, document.baseURI);
    if (dest.hash && dest.pathname === window.location.pathname && dest.origin === window.location.origin) {
      return;
    }
    if (window.location.href == new URL(href, document.baseURI).href) {
      e.preventDefault();
      e.stopPropagation();
      console.log('RETURN FALSE');
      return false;
    }
    // siomply update src with the new URL
    // window.location.href = href;
    if ( (href.includes(window.location.origin) || /^\//.test(href) || !/^http/.test(href)) && !target.hasAttribute('target') && !/mailto/.test(href) ) {
      e.preventDefault()
      e.stopPropagation()
      const url = new URL(href, document.baseURI ).toString();
      this.loadPageurl(url, target);
    }
    if (/\.pdf/.test(href)) {
      e.preventDefault()
      window.open(href, '_blank').focus();
    }
  }


  preparePage(url, target) {
    if (this.linksCache[url]?.pageContent) {
      return Promise.resolve(this.linksCache[url]);
    }
    if (this.linksCache[url]?.promise) {
      return this.linksCache[url].promise;
    }
    const promise = fetch(url)
      .then(res => {
        if (!res.ok) {
          throw new Error('PAGE_FETCH_FAILED');
        }
        return res.text();
      })
      .then(rawText => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(rawText, 'text/html');
        const $newPage = doc.body.querySelector('web-application');

        if (!$newPage) {
          console.log('CANNOT_FIND_PAGE_CONTAINER', doc.body);
          throw new Error('CANNOT_FIND_PAGE_CONTAINER');
        }
        const pageContent = $newPage.querySelector('[page-container]').innerHTML;
        const pageType = 'html';
        this.linksCache[url] = {
          pageContent,
          pageType,
          target,
        };
        return this.linksCache[url];
      });
    this.linksCache[url] = {
      promise,
      target,
    };
    return promise;
  }


    loadPageurl(url, target, skipPushState = false) {
    if (this.isTransitioning) {
      return;
    }
    this.beginTransition();
    if (!skipPushState) {
      history.pushState({}, "", url);
    }
    const pageReady = this.preparePage(url, target).catch(error => {
      this.endTransition();
      window.location.href = url;
      throw error;
    });
    this.transitionPage(url, target, pageReady);
  }
  
  async transitionPage(url, target, pageReady) {

    const $oldPageContainer = document.querySelector('[page-container]');
    const $pageParent = $oldPageContainer?.parentNode;

    if (!$oldPageContainer || !$pageParent) {
      this.endTransition();
      window.location.href = url;
      return;
    }

    const $overlay = document.createElement('div');
    $overlay.style.opacity = 0;
    $overlay.style.position = 'fixed';
    $overlay.style.top = '0px';
    $overlay.style.left = '0px';
    $overlay.style.height = '100vh';
    $overlay.style.width = '100%';
    $overlay.style.pointerEvents = 'auto';
    $overlay.style.zIndex = 999998;
    $pageParent.appendChild($overlay);

    let $newPageContainer;
    const createNewPageContainer = async () => {
      if ($newPageContainer) {
        return $newPageContainer;
      }
      const page = await pageReady;
      $newPageContainer = document.createElement('div');
      $newPageContainer.style.opacity = 0;
      $newPageContainer.style.position = 'fixed';
      $newPageContainer.style.top = '0px';
      $newPageContainer.style.left = '0px';
      $newPageContainer.style.height = '100vh';
      $newPageContainer.style.width = '100%';
      $newPageContainer.setAttribute('page-container', '');
      $newPageContainer.innerHTML = page.pageContent;
      $pageParent.appendChild($newPageContainer);
      return $newPageContainer;
    };

    requestAnimationFrame(async () => {

      let transitionNodeId;
      let transitionOverlayColor;
      let $imageTansitionNodeIn;
      let $imageTansitionNodeOut;

      if (target) {
        transitionNodeId       = target.getAttribute('transition-node-id');
        transitionOverlayColor = target.getAttribute('transition-overlay-color');
      }

      if (target && transitionNodeId) {

        const $newPageContainer = await createNewPageContainer();

        $imageTansitionNodeIn  = document.getElementById(transitionNodeId);
        $imageTansitionNodeOut = $newPageContainer.querySelector('[page-transition-image]');

        if ($imageTansitionNodeIn && $imageTansitionNodeOut) {

          let $transitionImage = $imageTansitionNodeIn.cloneNode();
          let boundsIn  = $imageTansitionNodeIn.getBoundingClientRect();
          let boundsOut = $imageTansitionNodeOut.getBoundingClientRect();

          if ($transitionImage) {

            $transitionImage.style.transform = `translate(${boundsIn.left}px, ${boundsIn.top}px) translateZ(0)`;
            $transitionImage.style.width = boundsIn.width + 'px';
            $transitionImage.style.height = boundsIn.height + 'px';
            $transitionImage.style.top = 0;
            $transitionImage.style.left = 0;
            $transitionImage.style.position = 'fixed';
            $transitionImage.style.zIndex = 999999;
            document.body.appendChild($transitionImage);

            requestAnimationFrame(() => {
              $imageTansitionNodeIn.style.opacity = 0;
              $imageTansitionNodeIn.style.transition = 'none';
            });

            Tween({v:0}, {
              to: {v:1},
              easing: [0.43, 0.195, 0.02, 1],
              duration: 1300,
              step: value => {
                $oldPageContainer.style.opacity = 1 - value;

                let x = boundsIn.left + (boundsOut.left - boundsIn.left) * value;
                let y = boundsIn.top + (boundsOut.top - boundsIn.top) * value;
                let w = boundsIn.width + (boundsOut.width - boundsIn.width) * value;
                let h = boundsIn.height + (boundsOut.height - boundsIn.height) * value;

                $transitionImage.style.transform = `translate(${x}px, ${y}px) translateZ(0)`;
                $transitionImage.style.width = w + 'px';
                $transitionImage.style.height = h + 'px';
              },
              end: () => {
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: 'auto',
                });

                Tween({v:0}, {
                  to: {v:1},
                  easing: [0.43, 0.195, 0.02, 1],
                  duration: 1300,
                  step: value => {
                    $newPageContainer.style.opacity = value;
                  },
                  end: () => {
                    window.scrollTo({
                      top: 0,
                      left: 0,
                      behavior: 'auto',
                    });
                    $overlay.parentNode?.removeChild($overlay);
                    $oldPageContainer.parentNode?.removeChild($oldPageContainer);
                    $newPageContainer.style?.removeProperty('position');
                    $newPageContainer.style?.removeProperty('top');
                    $newPageContainer.style?.removeProperty('left');
                    $newPageContainer.style?.removeProperty('height');
                    $newPageContainer.style?.removeProperty('clip-path');
                    $newPageContainer.style?.removeProperty('transform');
                    $transitionImage.parentNode?.removeChild($transitionImage);
                    this.endTransition();
  

 

                  }
                });
              }
            });

            return;
          }
        }
      }

      if (target && transitionOverlayColor) {

        $overlay.style.backgroundColor = transitionOverlayColor;

        Tween({v:0}, {
          to: {v:1},
          easing: [0.43, 0.195, 0.02, 1],
          duration: 1000,
          step: value => {
            $overlay.style.opacity = value;
            $overlay.style.zIndex = 10;
          },
          end: async () => {
            const $newPageContainer = await createNewPageContainer();
            $newPageContainer.style.zIndex = 11;
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'auto',
            });
            Tween({v:0}, {
              to: {v:1},
              easing: [0.43, 0.195, 0.02, 1],
              duration: 1300,
              step: value => {
                $newPageContainer.style.opacity = value;
                $newPageContainer.style.transform = `translateY(${window.innerHeight * 0.1 * (1 - value)}px) translateZ(0)`;
                $newPageContainer.style.clipPath = `inset(${20 * (1-value)}vh ${200 * (1-value)}px 0 ${200 * (1-value)}px round var(--radius-5fx)`;
              },
              end: () => {
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: 'auto',
                });
                  $overlay.parentNode?.removeChild($overlay);
                  $oldPageContainer.parentNode?.removeChild($oldPageContainer);
                $newPageContainer.style?.removeProperty('position');
                $newPageContainer.style?.removeProperty('top');
                $newPageContainer.style?.removeProperty('left');
                $newPageContainer.style?.removeProperty('height');
                $newPageContainer.style?.removeProperty('clip-path');
                $newPageContainer.style?.removeProperty('transform');
                $newPageContainer.style?.removeProperty('opacity');
                this.endTransition();
                
              }
            });
          }
        });
        return;
      }

      Tween({v:0}, {
        to: {v:1},
        easing: [0.43, 0.195, 0.02, 1],
        duration: 1000,
        step: value => {
          $oldPageContainer.style.opacity = 1 - value;
        },
        end: async () => {
          const $newPageContainer = await createNewPageContainer();
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto',
          });
          Tween({v:0}, {
            to: {v:1},
            easing: [0.43, 0.195, 0.02, 1],
            duration: 1300,
            step: value => {
              $newPageContainer.style.opacity = value;
            },
            end: () => {
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'auto',
              });
              $overlay.parentNode?.removeChild($overlay);
              $oldPageContainer.parentNode?.removeChild($oldPageContainer);
              $newPageContainer.style?.removeProperty('position');
              $newPageContainer.style?.removeProperty('top');
              $newPageContainer.style?.removeProperty('left');
              $newPageContainer.style?.removeProperty('height');
              $newPageContainer.style?.removeProperty('clip-path');
              $newPageContainer.style?.removeProperty('transform');
              $newPageContainer.style?.removeProperty('opacity');
              this.endTransition();
            }
          });
        }
      });

    });
  }

  clickSettingsToggle(event) {
    const type = event.currentTarget.dataset.siteSettingsType
    const isChecked = ((typeof event.currentTarget.ariaChecked === 'string' && event.currentTarget.ariaChecked === 'true')) ? true : false;
    console.log('clickSettingsToggle', event.currentTarget,{type, isChecked})
    this.updateSetting(type, !isChecked, true);
  }

  updateSetting(type, enabled, updateLocalStorage = false) {

    localStorage['accessibility'] = enabled;

    this.settings.accessibility.enabled = enabled;

    this.settings.accessibility.toggles?.forEach(toggle => {
      toggle.ariaChecked = enabled ? 'true' : 'false'; 
      toggle.parentNode.classList[ enabled ? 'add' : 'remove' ]('is-checked');
      const $status = toggle.parentNode.querySelector('[site-settings-status]');
      if ($status) {
        $status.textContent = toggle.dataset[ enabled  ? 'checkedStatus' : 'uncheckedStatus' ]
      }
    });
    
    document.documentElement.classList[ enabled ? 'add' : 'remove' ]('accessibility-mode');

    document.dispatchEvent(new CustomEvent(`site_settings_motion`, { detail: enabled ? 'off' : 'on' }));
    document.dispatchEvent(new CustomEvent(`accessibility-mode-change`, { detail: enabled }));
  
  }

  // siteMotionChange(event) {
  //   if (undefined === localStorage['motion']) {
  //     this.updateSetting('motion', event.matches)
  //   }
  // }

}

customElements.define('web-application', WebApplication)

